

export default function(state = null, action){
  if (action.type == 'SET_USER'){
    return action.user
  }
  return state
}


// WEBPACK FOOTER //
// ./src/store/user/reducer.js